import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AppParamsService } from 'src/app/services/app-params.service';
import { LeadService } from 'src/app/services/lead.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ActivatedRoute, Router } from '@angular/router';
import { GtmService } from 'src/app/services/gtm.service';
import { ToastrService } from 'src/app/services/toastr.service';
import { isPlatformBrowser } from '@angular/common';
import { LeadModel } from 'src/app/models/lead.model';
import { LinktrustService } from 'src/app/services/linktrust.service';
import { Params } from 'src/app/models/params.model';

import { OneSignal } from 'onesignal-ngx';
import { lastValueFrom } from 'rxjs';
import { SsrCookieService } from 'ngx-cookie-service-ssr';
import * as dateMath from 'date-arithmetic';
import { CryptoService } from 'src/app/services/crypto.service';




declare let TrackJS: any;

@Component({
  selector: 'app-lead-modal',
  templateUrl: './lead-modal.component.html',
  styleUrls: ['./lead-modal.component.css']
})
export class LeadModalComponent implements OnInit {


  public leadForm!: FormGroup;
  public processing: boolean = false;
  lead!: LeadModel;
  leadId!: number;
  public textButton = 'Un momento por favor';

  public emailValid: boolean;

  constructor(
    public modal: NgbActiveModal,
    private leadService: LeadService,
    private paramsService: AppParamsService,
    private deviceService: DeviceDetectorService,
    private router: Router,
    private aRoute: ActivatedRoute,
    private gtmService: GtmService,
    private toastService: ToastrService,
    @Inject(PLATFORM_ID) private platformId: any,
    private linktrustService: LinktrustService,
    private oneSignal: OneSignal,
    private cookieService: SsrCookieService,
    private cryptoService: CryptoService
  ) {

    this.lead = this.leadService.getLead();
    this.leadId = this.leadService.getLeadId();
    this.emailValid = true;
  }

  ngOnInit(): void {
    this.initForm();
  }

  initForm() {
    this.leadForm = new FormGroup({
      email: new FormControl(this.lead.email ? this.lead.email : '', [
        Validators.required,
        Validators.pattern(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)
      ]),
      mobile_number: new FormControl(this.lead.mobile_number ? this.lead.mobile_number : '', [
        Validators.required,
        Validators.minLength(10),
        Validators.maxLength(10),
        Validators.pattern(/[0-9]{10}/)
      ])
    });
  }


  async sendLead() {
    if (this.leadForm.invalid) {
      this.leadForm.markAllAsTouched();
      return;
    }


    var params = this.paramsService.getParams();
    var additionalParams: any = params.getAdditionalParams();
    var deviceInfo = this.deviceService.getDeviceInfo();

    if (additionalParams.hasOwnProperty('cp')) {
      this.textButton = 'Buscando mejores ofertas';
    }
    this.processing = true;

    var lead = this.leadService.getLead();
    lead.email = this.leadForm.value.email;
    lead.mobile_number = this.leadForm.value.mobile_number;
    lead.entry_url = this.paramsService.getEntryUrl();
    lead.last_step = "0";
    lead.utm_source = params.getUtmSource();
    lead.sid = params.getSid();
    lead.user_ip = params.getPublicIp();
    lead.application_path = 'MONEY_MARKET';
    lead.user_agent = this.deviceService.userAgent;
    lead.isMobile = this.deviceService.isMobile();
    lead.device_details = JSON.stringify(deviceInfo);
    lead.referrer = document.referrer;
    lead.sub_id = additionalParams['sub_id'] ? additionalParams['sub_id'] : "";


    var organicParams: any = {};
    var organicSourceRegex = new RegExp(/google|bing|yahoo/g);
    // generate click for organic search traffic
    if (this.paramsService.getParams().getUtmSource() === '418761'
      && organicSourceRegex.test(lead.referrer)
      && !lead.entry_url.includes('gclid')
    ) {
      console.log('Is organic search traffic');
      organicParams = await this.generateOrganicClick(lead);
      lead.sub_id = organicParams["sub_id"];
    }

    // GURAMI/GOOGLE CLICK
    if (this.paramsService.getParams().getUtmSource() === '426266' ||
      this.paramsService.getParams().getUtmSource() === '425145' ||
      this.paramsService.getParams().getUtmSource() === '569531'
    ) {
      console.log('Is custom affiliate traffic', this.paramsService.getParams().getUtmSource());
      organicParams = await this.generatAffiliateClick(this.paramsService.getParams(), lead);
      lead.sub_id = organicParams["sub_id"];
    }

    // One signal tags and metadata
    this.oneSignal.User.addTags({
      "email": lead.email,
      "mobile_number": lead.mobile_number,
      "origin": additionalParams['origin'] ? additionalParams['origin'] : params.getUtmSource()
    });

    this.lead = lead;
    this.leadService.setLead(lead);


    // var emailValidation = await lastValueFrom(this.leadService.validateEmail(lead.email));

    // let affrefcidorigin = additionalParams.AffRefCidOrigin || additionalParams.affRefCidOrigin
    // if (affrefcidorigin === '470737' && (emailValidation.status !== 'valid' && emailValidation.status !== 'catch-all')) {
    //   this.emailValid = false;
    //   console.log('Email invalido');
    //   this.processing = false;
    //   return;
    // } else {
    //   this.emailValid = true;
    // }

    this.leadService.createLead(lead).subscribe(leadResponse => {

      // fire events
      if (leadResponse.duplicated) {
        this.fireEvent(
          'lead_duplicated',
          leadResponse.id,
          lead.email,
          lead.mobile_number,
          encodeURIComponent(this.lead.user_agent),
          this.paramsService.getFbpCookie(),
          lead.sub_id
        );
      } else {
        this.fireEvent(
          'lead_new',
          leadResponse.id,
          this.lead.email,
          this.lead.mobile_number,
          encodeURIComponent(this.lead.user_agent),
          this.paramsService.getFbpCookie(),
          lead.sub_id
        );
      }
      this.fireEvent(
        'lead_general',
        leadResponse.id,
        this.lead.email,
        this.lead.mobile_number,
        encodeURIComponent(this.lead.user_agent),
        this.paramsService.getFbpCookie(),
        lead.sub_id
      );

      // update entry url with duplicated parameter
      // for propagate param to APIs redirect
      params.setGaid(this.paramsService.getGACookie());
      params.setGasd(this.paramsService.getGASessionIdCookie());
      params.setGasdn(this.paramsService.getGASessionIdNumberCookie());
      params.setfbp(this.paramsService.getFbpCookie());

      let entry_url = new URL(lead.entry_url);
      var queryParams: any = {
        dp: leadResponse.duplicated,
        gaid: params.getGaid(),
        gasd: params.getGasd(),
        gasdn: params.getGasdn(),
        fbp: params.getFbp()
      }

      entry_url.searchParams.append('dp', `${leadResponse.duplicated}`);
      entry_url.searchParams.append('gaid', `${params.getGaid()}`);
      entry_url.searchParams.append('gasd', `${params.getGasd()}`);
      entry_url.searchParams.append('gasdn', `${params.getGasdn()}`);
      entry_url.searchParams.append('fbp', `${params.getFbp()}`);

      if (!additionalParams.hasOwnProperty('t_email')) {
        entry_url.searchParams.append('t_email', `${lead.email}`);
        queryParams.t_email = lead.email;
      }
      if (!additionalParams.hasOwnProperty('t_num')) {
        entry_url.searchParams.append('t_num', `${lead.mobile_number}`);
        queryParams.t_num = lead.mobile_number;
      }

      lead.entry_url = entry_url.toString();

      this.leadService.setLead(lead);
      this.leadService.setLeadId(leadResponse.id);



      if (additionalParams.hasOwnProperty('cp')) {
        setTimeout(() => {
          this.router.navigate(['cuestionario2', 'resultado-xsell2'],
            organicParams
              ? { queryParams: { ...queryParams, ...organicParams }, queryParamsHandling: 'merge' }
              : { queryParams: queryParams, queryParamsHandling: 'preserve' }
          ).then(redirect => {
            this.modal.close('register');
            this.processing = false;
          });
        }, 3000);

      } else {
        this.router.navigate(['cuestionario2', 'paso-1'],
          organicParams
            ? { queryParams: { ...queryParams, ...organicParams }, queryParamsHandling: 'merge' }
            : { queryParams: queryParams, queryParamsHandling: 'preserve' }
        ).then(redirect => {
          this.modal.close('register');
          this.processing = false;
        });

      }




    }, err => {
      console.error(err.error);
      console.error(lead);

      if (isPlatformBrowser(this.platformId)) {
        TrackJS.track(err.error);
        TrackJS.track(lead);
      }

      this.toastService.show('Ha ocurrido un error inesperado, intente más tarde', { classname: 'bg-danger', delay: 10000 });
      this.processing = false;
    });


  }


  async generateOrganicClick(lead: LeadModel): Promise<any> {
    var organicResponse = await this.linktrustService.generateOrganicClick(
      '466010',
      '467832',
      'Organic-Search',
      {
        entry_url: lead.entry_url
      }
    );
    lead.sub_id = organicResponse.click_params.sub_id;
    lead.utm_source = organicResponse.click_params.utm_source;
    lead.sid = organicResponse.click_params.SID;
    organicResponse.click_params.AffiliateReferenceID = organicResponse.click_params.sub_id;

    this.paramsService.setParams(organicResponse.click_params);
    return organicResponse.click_params;

  }



  async generatAffiliateClick(params: Params, lead: LeadModel): Promise<any> {
    var response = await this.linktrustService.generateOrganicClick(
      '466010',
      params.getUtmSource(),
      params.getSid(),
      params.getAdditionalParams()
    );
    lead.sub_id = response.click_params.sub_id;
    lead.utm_source = response.click_params.utm_source;
    lead.sid = response.click_params.SID;
    response.click_params.AffiliateReferenceID = response.click_params.sub_id;

    this.paramsService.setParams(response.click_params);
    return response.click_params;

  }


  async fireEvent(event_name: string, idLead: number, email: string, mobile_number: string, encodedUserAgent: string, fbp: string, clickId: string) {

    // fire event lead_general for Aff Model
    if (event_name === 'lead_general' && this.cookieService.get('lastRegistryEmail') === email) {
      console.log('same lead last hour');
      this.gtmService.customEvent('lead_general', {
        id_lead: idLead,
        hid: await this.cryptoService.generateSha256Hash(idLead.toString()),
        email: email,
        he: await this.cryptoService.generateSha256Hash(email),
        mobile_number: '+52' + mobile_number,
        hm: await this.cryptoService.generateSha256Hash(mobile_number),
        duplicatedLastHour: true,
        encodedUserAgent: encodedUserAgent,
        fbp: fbp,
        ojo7_click_id: clickId,
        user_data: {
          email_address: email,
          phone_number: '+52' + mobile_number,
        }
      });
      this.cookieService.set('lastRegistryEmail', email, { path: '/', expires: dateMath.add(new Date(), 1, 'hours'), sameSite: 'Strict' });
      return;
    }

    this.gtmService.customEvent(event_name,
      {
        id_lead: idLead,
        email: email,
        mobile_number: '+52' + mobile_number,
        duplicatedLastHour: false,
        encodedUserAgent: encodedUserAgent,
        fbp: fbp,
        ojo7_click_id: clickId,
        user_data: {
          email_address: email,
          phone_number: '+52' + mobile_number,
        }
      });
  }

  isNumber(event: any) {
    const pattern = /[0-9]/;
    var value = this.leadForm.value.mobile_number
      ? this.leadForm.value.mobile_number.toString() : '';
    if (!pattern.test(event.key) || value.length > 9) {
      // invalid character, prevent input
      event.preventDefault();
    }
  }


  get emailRequiredValidation() {
    if (!this.leadForm.get('email')!.valid) {
      return this.leadForm.get('email')!.errors!['required'] && this.leadForm.get('email')!.touched;
    }
    return false;
  }


  get emailPatternValidation() {
    if (!this.leadForm.get('email')!.valid) {
      return this.leadForm.get('email')!.errors!['pattern'] && this.leadForm.get('email')!.touched;
    }
    return false;
  }

  get mobileNumberRequiredValidation() {
    if (!this.leadForm.get('mobile_number')!.valid) {
      return this.leadForm.get('mobile_number')!.errors!['required'] && this.leadForm.get('mobile_number')!.touched;
    }

    return false;
  }

  get mobileNumberMinLengthValidation() {
    if (!this.leadForm.get('mobile_number')!.valid) {
      return this.leadForm.get('mobile_number')!.errors!['minlength'] && this.leadForm.get('mobile_number')!.touched;
    }
    return false;
  }

  get mobileNumberMaxLengthValidation() {
    if (!this.leadForm.get('mobile_number')!.valid) {
      return this.leadForm.get('mobile_number')!.errors!['maxlength'] && this.leadForm.get('mobile_number')!.touched;
    }
    return false;
  }


  get mobileNumberPatternValidation() {
    if (!this.leadForm.get('mobile_number')!.valid) {
      return this.leadForm.get('mobile_number')!.errors!['pattern'] && this.leadForm.get('mobile_number')!.touched;
    }
    return false;
  }


  validField(controlName: string) {
    if (this.leadForm.get(controlName)!.valid) {
      return true;
    }
    return false;
  }

}
